<template>
    <div>
        <div class="main_box px1005 box950" style="padding-left:30px;box-sizing: content-box;">
               <nav>
                   <a class="maincolor" href="/">首页</a> <span class="c-666 en">&gt;</span>专家服务
               </nav>
           </div>
        <div class="g-carousel" id="J-index-banner-slide" style="min-width: 1200px;">
            <div class="g-carousel-viewport">
                <ul class="g-carousel-inner">
                    <img src="../../assets/images/zjservice/页面图片修改2-1.png" style="width: 100%;" height="280">
                </ul>
            </div>
        </div>
        <div class="" style="background:#fffdc5; padding-top:30px;">
            <div class="conent_ydy" style="position: relative;">
            <img src="../../assets/images/zjservice/页面图片修改2-2.png" width="1198" height="392">
            <div style="color: black;font-size: 15px;font-weight: 700;position: absolute;left: 142px;top: 349px;">
                12.51%的上线考生落榜</div>
            <div style="color: black;font-size: 15px;font-weight: 700;position: absolute;left: 434px;top: 349px;">
                19.62%的考生高分低就</div>
            <div style="color:black;font-size: 15px;font-weight: 700;position: absolute;left: 688px;top: 349px;">
                22.31%的考生滑档退档</div>
            <div style="color:black;font-size: 15px;font-weight: 700;position: absolute;left: 941px;top: 349px;">
                38%的考生专业被调剂</div>
            <img src="../../assets/images/zjservice/页面图片修改2-3.png" width="1198" height="275">
            <div style="color: white;font-size: 23px;position: absolute;top: 480px;left:190px;letter-spacing: 4px;">
                志愿风险</div>
            <div style="color: white;font-size: 15px;position: absolute;top: 450px;left:420px;letter-spacing: 3px;">
                掌握的数据信息不全</div>
            <div style="color: white;font-size: 15px;position: absolute;top: 450px;left:690px;letter-spacing: 3px;">
                不懂录取规则</div>
            <div style="color: white;font-size: 15px;position: absolute;top: 450px;left:950px;letter-spacing: 3px;">
                不能准确的预测
            </div>
            <div style="display: flex;justify-content: center;
            align-items: center;height: 160px; color: black;font-size: 15px;
            font-weight: 700;letter-spacing: 5px;position: absolute;top: 512px;left: 394px;">
                <p style="width: 200px;;">考生、家长在选择大学
                    时，仅仅凭往年录取的
                    最低分和录取最低提名
                    挑选大学，因数据单
                    一、信息不全、又不懂
                    分析和预测，从而想当
                    然的报考。</p>
            </div>
            <div style="display: flex;justify-content: center;
            align-items: center;height: 110px; color: black;font-size: 15px;
            font-weight: 700;letter-spacing: 5px;position: absolute;top: 502px;left: 652px;">
                <p style="width: 200px;">
                    不懂平行志愿的录取规
                    则，不懂大学的录取规
                    则，特别是专业录取规
                    则，盲目填报，导致退
                    档、专业别调剂！</p>
            </div>
            <div style="display: flex;justify-content: center;
            align-items: center;height: 174px; color: black;font-size: 15px;
            font-weight: 700;letter-spacing: 4px;position: absolute;top: 502px;left: 912px;">
                <p style="width: 200px;">
                    每个大学每年的录取变化多端，忽高忽低，考生、家长又不懂得分析、
                    计算，判断录取趋势，从而不能根据自己的实际考分做出合理的选择
                    导致高分低就、滑档退档、专业被调剂！</p>
            </div>
            <img src="../../assets/images/zjservice/页面图片修改2-4.png" width="1198" height="366">
            <img src="../../assets/images/zjservice/页面图片修改2-5.png" width="1198" height="469">
            <img src="../../assets/images/zjservice/页面图片修改2-6.png" width="1198" height="1127">
            <div style="display: flex;justify-content: space-around;align-items: center;flex-direction: column;
            color: black;letter-spacing: 3px;font-size: 20px;height: 300px;position: absolute;top: 1706px;left: 537px;">
                <p style="width: 640px;font-weight: 700;">服务内容：</p>
                <p style="width: 640px;">
                    1、 高考志愿填报一对一个性化指导，
                    综合学校、 专业、兴趣、职业等因素，
                    制定最适合考生的志愿填报方案。</p>
                <p style="width: 640px;">
                    2、 家长科学助考辅导， 指导家长如何做好高三考生的得力帮手和志愿填报参谋。
                </p>
                <p style="width: 640px;">
                    3、 沟通零距离志愿专家、 家长和考生本人直接面对面交流沟通。
                </p>
                <p style="width: 640px;">
                    4、多层审核机制 ， 确保用户志愿方案的有效性和科学性。
                </p>
            </div>
            <div style="display: flex;justify-content: space-around;align-items: center;flex-direction: column;
            color: black;letter-spacing: 3px;font-size: 20px;height: 110px;position: absolute;top: 2306px;left: 147px;">
                <p style="width: 480px;">1、服务以面谈， 电话， 网络等方式开展。</p>
                <p style="width: 480px;">2、权威专家为您量身打造最佳志愿填报方案。</p>
            </div>
            <img src="../../assets/images/zjservice/页面图片修改2-7.png" width="1198" height="501">
            <div style="font-size: 17px;color: black;font-weight: 700;display: flex;justify-content: space-between;align-items: center;
            flex-direction: column;height: 300px;padding-top: 6px;padding-bottom: 10px; box-sizing: border-box;
             position: absolute;top: 2700px;left: 500px;">
                <p style="width: 530px;">选择志愿专家，点击在线预约服务，或拨打全国热线服务电话预约咨询</p>
                    <p style="width: 530px;">选专家与考生、家长面谈，进一步了解报考服务内容及服务流程</p>
                    <p style="width: 530px;">与家长签订委托书，付费、递交考生基本信息资料</p>
                    <p style="width: 530px;">专家与考生、家长多次面谈，详细了解考生及家长意愿，制定职业规划</p>
                    <p style="width: 530px;">根据专家服务流程，制定考生服务计划，并确定考生报考方案</p>
                <p style="width: 530px;">回访了解考生报考情况，再次制定应急报考方案</p>
            </div>
            </div>
            <div class="conent_zj">
                    <ul>
                        <li v-for="(item,index) in expert_list" :key="index">
                        <div class="con1" style="height:260px;">
                            <div class="left_wen">
                            <h1>专家姓名：{{item.name}} &nbsp;&nbsp;指导领域：{{item.area_name}}</h1>
                            <div style="height:160px; overflow:hidden;">
                                    <el-tooltip placement="top">
                                        <div slot="content" style="width: 800px;">简介：{{item.description}}</div>
                                        <p style="height:160px;">简介：{{item.description}}</p>
                                    </el-tooltip>
                            </div>
                            <div class="bottom_wh"><a style="cursor: default;">服务类型：{{item.type_code==1?"权威专家服务":item.type_code==2?"一般专家服务":""}}</a><a style="cursor: default;">指导名额：{{item.server_num}}</a></div>
                            <div></div>
                            </div>
                            <div class="right_tu">
                                <!-- <img src="../../assets/attached/image/20170227/20170227153509_969.jpg" width="141" height="141"> -->
                                <!-- <img src="../../assets/attached/image/20170227/20170227153509_969.jpg" width="180" height="220"> -->
                                <img :src=item.pic width="180" height="220">
                            </div>
                            <!-- <div class="right_tu2">
                                <a class="btn btn-primary" target="_blank"
                                :href="'http://wpa.qq.com/msgrd?v=3&uin='+item.qq_num+'&site=qq&menu=yes&from=message&isappinstalled=0'">点击预约服务</a>
                            </div> -->
                        </div>
                        </li>
                    </ul>

            </div>
        </div>
    </div>
</template>
<script>
import {mapState} from 'vuex';
export default {
data(){
    return{
        expert_list:[]
        // obj:{
        //     name:"蒋老师",
        //     area_name:"湖南",
        //     description:"重点大学某高校一线教师，从事招生工作十余年，对专业的解读和把握具有丰富经验。",
        //     type_code:1,
        //     server_num:"20",
        //     qq_num:"2675338431"
        // }
    };
},
methods:{
    zjServiceClick(paramObj){
    // 点击调用qq服务
                var qqUrl = 'http://wpa.qq.com/msgrd?v=3&uin='+paramObj+'&site=qq&menu=yes&from=message&isappinstalled=0';
                window.open(qqUrl,'');
    },
    // 获取专家的信息
    async getZjxx(){
        const res=await this.$http.getHttp("/zjxx/queryZjxx");
        if(res.data.code===200){
            const arr=res.data.obj;
            for(let i=0;i<arr.length;i++){
                if(arr[i].name){
                    const pic=arr[i].pic;
                    arr[i].pic=require('@/assets'+pic);
                    console.log(arr[i].pic);
                }
            }
            this.expert_list=arr;
        }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:'error'});
            }
        }else if(res.status===401){
                this.$message({message: '登录超时，请重新登录',type:"error"});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
        }else if(res.data.code===0){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
        }else if(res.status===409||res.status===410||res.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
    }
},
async mounted(){
await this.getZjxx();
},
computed:{
    ...mapState(["userInfo"])
}
};
</script>
<style lang="less" scoped>
    .g-carousel{
        border: none;
        position: relative;
        width: 100%;
    }
    .g-carousel-viewport {
         position: relative;
         overflow: hidden;
         border: none;
         width: 100%;
     }
     ul.g-carousel-inner {
          list-style: none;
          position: relative;
          overflow: hidden;
      }
    img {
        margin: 0px;
        padding: 0px;
        list-style-type: none;
    }
    .conent_ydy {
        width: 1200px;
        height: auto;
        margin: 0 auto;
        padding: 10px 0 0 0;
        background: #fffdc5;
    }
    .conent_zj {
        width: 1185px;
        height: auto;
        margin: 0 auto;
        padding: 10px 0 25px 25px;
        background: #fffdc5;
        overflow: hidden;
    }
    .con1 {
        width: 529px;
        height: 243px;
        float: left;
        margin-left: 25px;
        background: #FFF;
        border: 2px solid #a0a0a0;
        margin-top: 25px;
    }
    .con1 .left_wen {
        width: 328px;
        height: 220px;
        float: right;
        margin-top: 25px;
        margin-left: 10px;
    }
    .con1 .left_wen h1 {
        font-size: 16px;
        font-family: microsoft yahei;
        background: #F00;
        color: #fff;
        font-weight: normal !important;
        height: 25px;
        line-height: 25px;
        margin: 0px;
        text-indent: 15px;
        padding: 0px;
    }
    .con1 .left_wen p {
        color: #615f5f;
        margin-top: 10px;
    }
    .con1 .bottom_wh {
        width: 328px;
        height: 35px;
        line-height: 35px;
        margin-top: 10px;
    }
    .con1 .right_tu {
        width: 154px;
        height: 154px;
        float: left;
        margin-top: 25px;
        margin-left: 10px;
    }
    .con1 .right_tu2 {
        width: 154px;
        height: 35px;
        float: left;
        margin-top: 15px;
        margin-left: 10px;
    }
    .btn:first-child {
        *margin-left: 0;
        width: 141px;
    }
    button, html input[type="button"], input[type="reset"], input[type="submit"] {
        cursor: pointer;
        -webkit-appearance: button;
    }
    .btn-primary {
        color: #fff;
        background-color: #19ca9e;
        border-color: #19ca9e;
        width: 141px;
    }
    .btn {
        display: inline-block;
        text-align: center;
        font-weight: 600;
        white-space: nowrap;
        vertical-align: middle;
        -webkit-transition: background-color .1s linear;
        -moz-transition: background-color .1s linear;
        -o-transition: background-color .1s linear;
        transition: background-color .1s linear;
        border-radius: 0px !important;
        border: 0px currentColor;
        border-image: none;
        color: rgb(255, 255, 255) !important;
        box-shadow: none;
        text-shadow: none;
        background-image: none;
        background-repeat: no-repeat;
        user-select: none;
        margin-bottom: 0px;
        font-size: 12px;
        line-height: 1.4285;
        padding: 6px 12px;
    }
    input{
    outline: none;
    font-family: "Microsoft YaHei", SimSun, Arial, sans-serif !important;
    margin-left: 0px;
    margin: 0;
    }
    .con1 .bottom_wh a {
        display: block;
        width: 150px;
        float: left;
        height: 35px;
        line-height: 35px;
        // background: url(../assets/images/listc.jpg) no-repeat 0px;
        font-family: microsoft yahei;
        font-size: 12px;
        color: #c91e18;
        text-indent: 15px;
    }
    
// h1,h2,h3,h4,h5,h6{
//     margin: 0 !important;
//     font-weight: 700 !important;
// }
</style>
